import { render, staticRenderFns } from "./vediGiudizi.vue?vue&type=template&id=4ad8ce7d&"
import script from "./vediGiudizi.vue?vue&type=script&lang=js&"
export * from "./vediGiudizi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports